module.exports = __webpack_public_path__ + "static/2017-RISE-Poster-177d4bfa6184b978cac778fc22c2279a.pdf";